import { render, staticRenderFns } from "./AtomLogoEdition.vue?vue&type=template&id=296fd68a&"
import script from "./AtomLogoEdition.vue?vue&type=script&lang=js&"
export * from "./AtomLogoEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports